import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-logos-link-icon',
  templateUrl: './logos-link-icon.component.html'
})
export class LogosLinkIconComponent implements OnInit {

  constructor() { }
  @Input() logo
  @Output() closeTooltipEmitter = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  medias: MediaInterface[] = [
    { style: 'thumbnail', media: '(min-width:268px)' }
  ]

  ngOnInit(): void {
  }

}
